// TransactionHistory.jsx or .tsx
import React from 'react';
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Chip,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import PaidIcon from "../../assets/paidicon.png"
import Refundicon from "../../assets/refund.png"

const transactions = [
  { id: 1, transactionType: 'Paid', amount: '$120.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 2, transactionType: 'Refund', amount: '$45.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 3, transactionType: 'Paid', amount: '$300.00',orderId:"237834687364198" ,timestamp:"32742893428937"},
  { id: 4, transactionType: 'Refund', amount: '$20.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 5, transactionType: 'Paid', amount: '$500.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 6, transactionType: 'Paid', amount: '$75.00' ,orderId:"237834687364198",timestamp:"32742893428937"},
    { id: 1, transactionType: 'Paid', amount: '$120.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 2, transactionType: 'Refund', amount: '$45.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 3, transactionType: 'Paid', amount: '$300.00',orderId:"237834687364198" ,timestamp:"32742893428937"},
  { id: 4, transactionType: 'Refund', amount: '$20.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 5, transactionType: 'Paid', amount: '$500.00',orderId:"237834687364198",timestamp:"32742893428937" },
  { id: 6, transactionType: 'Paid', amount: '$75.00' ,orderId:"237834687364198",timestamp:"160303105132"},
];

const TransactionHistory = ({tagListHistory}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  function TruncatedOrderId({ text, limit }) {
    if (text&&text.length <= limit) {
      return <>{text}</>;
    }
    return <>{`${text.substring(0, limit)}...`}</>;
  }
  return (
    <Box
      sx={{
      
        width: '100%' ,
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
       
      
        gap: 2,
      }}
    >


      {/* Scrollable Transaction List */}
      <Box
        sx={{
         
          overflowY: 'auto',
         
          borderRadius: 2,
          padding: 1,
           maxWidth:"400px",
           width:"100%"
        }}
        
      >
        <div style={{marginTop:"18rem"}}>
      {transactions.reverse()?.length > 0 && (
  <div
    style={{
      overflowX: "auto",
      overflowY: "hidden",
      whiteSpace: "nowrap",
     
      gap: "12px",
      padding: "1rem 0",
    }}
  >
    {tagListHistory&&tagListHistory.data&&tagListHistory.data.payload.reverse().map((el, index) => (
      <div
        key={index}
        className="_2NVhy _3hjyL"
        style={{
          minWidth: "260px", // Fixed width to force horizontal layout
          flex: "0 0 auto",
         
        }}
      >
        <div
          className="styles_slider__podEu"
          data-testid="grid-slider"
          style={{ marginTop: "-11%",    padding: "1%" }}
        >
          <div
            className="styles_row__1ivP1 shadow-box"
            data-testid="grid-row"
            style={{
              marginTop: "4%",
              marginTop: "3rem",
              height: "81px",
              background: "#FFF",
              borderRadius: "16px",
              boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding:"20px"
              }}
            >
              <div>
                
                {el.opsType === "debit" ? (
                  <img style={{ width: "44px" }} src={PaidIcon} />
                ) : (
                  <img style={{ width: "44px" }} src={Refundicon} />
                )}
              </div>
              <div style={{ marginLeft: "-10%" }}>
                {el.opsType === "debit" ? (
                  <h3
                    style={{
                      color: "#333F4E",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "600",
                      lineHeight: "150%",
                      letterSpacing: "0.2px",
                    }}
                  >
                    Paid amount
                  </h3>
                ) : el.transactionType === "money_add" ? (
                  <h3
                    style={{
                      color: "#583C43",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Balance added
                  </h3>
                ) : (
                  <h3
                    style={{
                      color: "#333F4E",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Refunded amount
                  </h3>
                )}
                <p
                  style={{
                    marginTop: "5px",
                    fontSize: "12px",
                    color: "#64748B",
                  }}
                >
                  ID: <TruncatedOrderId text={el.orderId} limit={20} />
                </p>
              </div>

              <div>
                {el.opsType === "debit" ? (
                  <h3
                    style={{
                      color: "#F43F5E",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "150%",
                      letterSpacing: "0.2px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    ₹{el.amount}
                  </h3>
                ) : el.transactionType === "money_add" ? (
                  <h3
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      color: "#00B177",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "150%",
                      letterSpacing: "0.2px",
                    }}
                  >
                    ₹{el.amount}
                  </h3>
                ) : (
                  <h3
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      color: "#583C43",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "150%",
                      letterSpacing: "0.2px",
                    }}
                  >
                    ₹{el.amount}
                  </h3>
                )}
                <p
                  style={{
                    color: "#94A3B8",
                    textAlign: "right",
                    fontFamily: "Roboto",
                    fontSize: "11px",
                    fontWeight: "400",
                    lineHeight: "150%",
                    letterSpacing: "0.2px",
                  }}
                >
                  {el.timestamp.slice(0, 10)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)}

        </div>
      </Box>
    </Box>
  );
};

export default TransactionHistory;
